export const gameState = {
  currentPanel: 1 as 0 | 1,
};
